// 引入axios
import axios from 'axios'
// 引入qs模块 用来序列化post类型的数据
import QS from 'qs'
// import router from '../router/index'
import { ElLoading } from 'element-plus'
import domMessage from './messageOnce'
import router from '@/router/index.js'
import { baseURL } from './config'

// baseURL 统一从 config.js 读取，切换环境只需修改 config.js
axios.defaults.baseURL = baseURL

// 全局loading
let loadingInstance = {}

// 设置请求超时
axios.defaults.timeout = 3000000

// Content-Type: application/json ： 请求体中的数据会以json字符串的形式发送到后端
// Content-Type: application/x-www-form-urlencoded：请求体中的数据会以普通表单形式（键值对）发送到后端
// Content-Type: multipart/form-data： 它会将请求体的数据处理为一条消息，以标签为单元，用分隔符分开。既可以上传键值对，也可以上传文件。
// post请求头的设置
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 设置请求头带凭证
// 错误提示
const messageOnce = new domMessage()
const tip = (msg) => {
  messageOnce.error(msg.msg)
}

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    if (axios.defaults.headers.post != 'application/x-www-form-urlencoded;charset=UTF-8') {
      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    }

    config.headers.authorize = 'Bearer' + localStorage.getItem('token');
    loadingInstance = ElLoading.service({ fullscreen: true, text: '努力加载中~' })
    return config
  },
  (error) => {
    loadingInstance.close()
    return Promise.error(error)
  }
)
axios.interceptors.response.use(response => {
  // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
  // 否则的话抛出错误
  loadingInstance.close()
  if (response.data.code === 200) {
    return Promise.resolve(response)
  } else if (response.data.code === 401) {
    localStorage.removeItem('token')
    router.push('/')
    return  tip(response.data)
    //  tip(response.data)
    //  return Promise.reject(response) // 👈 标准写法

  } else if (response.data.type == 'application/octet.stream') {
    return Promise.resolve(response)
  } else {
    //  tip(response.data)
    //  return Promise.reject(response) // 👈 标准写法
     return tip(response.data)
  }
}, error => {
  tip('请求失败，请联系管理员')
   loadingInstance.close()
  //  Promise.reject(error)
})
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        paramsSerializer: (params) => {
          // 处理数组参数，转换成 `key=value1&key=value2` 格式
          const parts = [];
          Object.keys(params).forEach(key => {
            const value = params[key];
            if (Array.isArray(value)) {
              value.forEach(item => parts.push(`${key}=${encodeURIComponent(item)}`));
            } else if (value !== undefined && value !== null) {
              parts.push(`${key}=${encodeURIComponent(value)}`);
            }
          });
          return parts.join("&");
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
// 修改post方法（去掉QS序列化）
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, { // 直接传JSON对象
        headers: {
          'Content-Type': 'application/json;charset=UTF-8' // 修改为JSON类型
        }
      })
      .then(resolve)
      .catch(reject)
      // .then((res) => {
      //   resolve(res.data); // 👈 只加这一句
      // })
      // .catch((err) => {
      //   reject(err.data);
      // });
  })
}

// const showStatus = (status) => {
//   let message = ''
//   switch (status) {
//     case 400:
//       message = '请求错误(400)'
//       break
//     case 401:
//       message = '未授权，请重新登录(401)'
//       break
//     case 403:
//       message = '拒绝访问(403)'
//       break
//     case 404:
//       message = '请求出错(404)'
//       break
//     case 408:
//       message = '请求超时(408)'
//       break
//     case 500:
//       message = '服务器错误(500)'
//       break
//     case 501:
//       message = '服务未实现(501)'
//       break
//     case 502:
//       message = '网络错误(502)'
//       break
//     case 503:
//       message = '服务不可用(503)'
//       break
//     case 504:
//       message = '网络超时(504)'
//       break
//     case 505:
//       message = 'HTTP版本不受支持(505)'
//       break
//     default:
//       message = `连接出错(${status})!`
//   }
//   return tip(`${message}，请检查网络或联系管理员！`)
// }
